/**
 * Canonical catalog of reseller-portal sidebar items a parent can show/hide
 * for a managed child (EPIC #92). `key` is the stable identifier stored in the
 * invite's HiddenNavKeys list (and read back in getMe). `defaultHidden` items
 * start OFF when inviting a child — the parent already set those up.
 *
 * Dashboard is the portal home (the header/account-name link points there) and
 * is intentionally NOT listed — it's always visible.
 *
 * `section` groups items the same way the sidebar does so the toggle UI and
 * the sidebar stay aligned. Keep this list in sync with ResellerShell's nav.
 */
export const RESELLER_MENU_ITEMS = [
  // Setup
  { key: 'brand',            section: 'setup',   labelKey: 'sp_brand_profile_title',     fallback: 'Brand profile' },
  { key: 'emailIntegration', section: 'setup',   labelKey: 'sp_email_integration_title', fallback: 'Email integration' },
  { key: 'connectedCourses', section: 'setup',   labelKey: 'sp_connected_courses_title', fallback: 'Connected courses', defaultHidden: true },
  { key: 'payment',          section: 'setup',   labelKey: 'sp_payment_setup_title',     fallback: 'Payment setup' },
  { key: 'apiAccess',        section: 'setup',   labelKey: 'sp_api_access',              fallback: 'API access', defaultHidden: true },
  { key: 'team',             section: 'setup',   labelKey: 'sp_nav_team',                fallback: 'Team', defaultHidden: true },
  // Build
  { key: 'groupings',        section: 'build',   labelKey: 'sp_nav_groupings_packages',  fallback: 'Stay & Play Packages' },
  { key: 'golfBundles',      section: 'build',   labelKey: 'sp_nav_golf_bundles',        fallback: 'Golf Bundles' },
  { key: 'customTrips',      section: 'build',   labelKey: 'sp_nav_custom_trips',        fallback: 'Custom Trips' },
  { key: 'netRateProperties', section: 'build',  labelKey: 'sp_nav_net_rate',            fallback: 'Net-rate properties' },
  { key: 'promoCodes',       section: 'build',   labelKey: 'sp_nav_promo_codes',         fallback: 'Promo Codes' },
  { key: 'managedAccounts',  section: 'build',   labelKey: 'sp_managed_accounts',        fallback: 'Managed accounts', defaultHidden: true },
  // Operate
  { key: 'bookings',         section: 'operate', labelKey: 'sp_nav_bookings',            fallback: 'Bookings' },
  { key: 'toBook',           section: 'operate', labelKey: 'sp_nav_to_book',             fallback: 'To book' },
  { key: 'coursePayments',   section: 'operate', labelKey: 'sp_nav_course_payments',     fallback: 'Course payments' },
  { key: 'messages',         section: 'operate', labelKey: 'sp_nav_messages',            fallback: 'Messages' },
  { key: 'changeRequests',   section: 'operate', labelKey: 'sp_cr_title_plural',         fallback: 'Change requests' },
  { key: 'reviews',          section: 'operate', labelKey: 'sp_nav_reviews',             fallback: 'Reviews' },
  { key: 'notifications',    section: 'operate', labelKey: 'sp_nav_notifications',        fallback: 'Notifications' },
  { key: 'emailHistory',     section: 'operate', labelKey: 'sp_email_history',           fallback: 'Email history' },
  { key: 'customDomain',     section: 'operate', labelKey: 'sp_dash_row_custom_domain',  fallback: 'Custom domain' },
]

// Keys hidden by default for a freshly invited managed child.
export const DEFAULT_HIDDEN_NAV = RESELLER_MENU_ITEMS.filter(i => i.defaultHidden).map(i => i.key)
